import { getFileFormatInfo } from './fileFormat';
import { isAudioLikeFile } from './audioChat';

export function isImageLikeFile(file: File): boolean {
  return (
    !isAudioLikeFile(file) &&
    (getFileFormatInfo(file.name).isImage || file.type.startsWith('image/'))
  );
}

/** Paper 5BL — e.g. "2048×2560 JPG" */
export function formatImageDimensionsForChat(file: File, naturalW: number, naturalH: number): string {
  if (!Number.isFinite(naturalW) || !Number.isFinite(naturalH) || naturalW <= 0 || naturalH <= 0) return '';
  const info = getFileFormatInfo(file.name);
  return `${Math.round(naturalW)}×${Math.round(naturalH)} ${info.label}`;
}

export function singleFileLoadedMessageWithImageMeta(fileName: string, dimFormatLabel: string): string {
  return `[${fileName}] loaded — ${dimFormatLabel}. What would you like to do with it?`;
}

/** Paper 5BL — chat rail chips + input pills for a single image in doc view */
export const IMAGE_CHAT_QUICK_ACTIONS: readonly { label: string; prompt: string }[] = [
  { label: 'Remove background', prompt: 'Remove the background' },
  { label: 'Describe image', prompt: 'Describe this image in detail.' },
  { label: 'Extract text', prompt: 'Extract all text from this image using OCR.' },
];

/** Paper 5B7 — document column footer (same prompts + + Ask) */
export const IMAGE_DOCUMENT_BOTTOM_ACTIONS: readonly { label: string; prompt: string | null }[] = [
  ...IMAGE_CHAT_QUICK_ACTIONS.map((a) => ({ label: a.label, prompt: a.prompt })),
  { label: '+ Ask', prompt: null },
];
